import { Component, EventEmitter, Input, Output, computed } from '@angular/core';
import { Store } from '@ngxs/store';
import { Application } from 'app/models/dto/deal-application.model';
import { Deal } from 'app/models/dto/deal.model';
import { Offer } from 'app/services/offers/offer.model';
import {
  DealApplicationQuestionRequirement
} from 'app/store/deal/deal-application-requirements/deal-application-requirement.state';
import { DocumentState } from 'app/store/documents/document.state';
import { DealDocumentState } from 'app/store/deal/deal-documents/deal-document.state';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';
import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';
import { LenderUserState } from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import { ApprovalsState } from 'ng2-app/store/offers/approvals.state';

@Component({
  selector: 'app-deal-advanced',
  templateUrl: './advanced-deal.component.html',
  styleUrls: ['./advanced-deal.component.scss'],
  standalone: false
})
export class AdvancedDealComponent {
    @Input() approvals: Approval[] = [];
    @Input() offerOptions: OfferOption[] = [];
    @Input() bulkSubmitting = false;
    @Input() deal: Deal;
    @Input() offers: Offer[];
    @Input() questions: DealApplicationQuestionRequirement | null;
    @Input() applications: Application[];
    @Input() appQuestionsLoading: boolean;
    @Input() hasSignedApplication: boolean;
    @Input() canReactivateDeals: boolean;
    @Input() questionRequirementsMet: boolean;
    @Input() dateSigned: string;
    @Input() readOnly: boolean = false;
    @Input() showDealRightColumn: boolean = true;
    @Input() hasContractRequest: boolean = false;

    @Output() appComplete = new EventEmitter();
    @Output() submit = new EventEmitter<boolean>();

    approvalsLoading = this.store.selectSignal( ApprovalsState.loading );
    canSeeFunctionalApprovals = this.store.selectSignal( LenderUserState.hasPermission('PL:functionalApprovals.read') );
    canRecommendOptions = this.store.selectSignal( LenderUserState.hasPermission('recommendFinancingOptions') );
    advancedDealDocumentRequirements = this.store.selectSignal( DealDocumentState.advancedDealDocumentRequirements );
    documentCategories = this.store.selectSignal( DocumentState.documentCategories );
    borrowerDocuments = this.store.selectSignal( DocumentState.documents );
    currentUser = this.store.selectSignal( LenderUserState.lenderUser );
    dealDocumentsSignal = this.store.selectSignal( DealDocumentState.advancedDealDocuments );
    dealDocuments = computed(() => {
      const signal = this.dealDocumentsSignal();
      return signal ? signal(this.deal?.id) : [];
    });

    constructor(private store: Store){}

    closer() {
        return this.deal.closer ? `${this.deal.closer.first} ${this.deal.closer.last}` : null;
    }
}
